import React from 'react'
import {
    Checkbox as ChakraCheckbox,
    useStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import CheckIcon from '../../components/icons/others/CheckIcon'
import PropTypes from 'prop-types'

const CustomCheckIcon = (props) => {
    const {isChecked, ...rest} = props
    return isChecked ? <CheckIcon {...rest} /> : null
}

CustomCheckIcon.propTypes = {
    isChecked: PropTypes.bool,
}

const Checkbox = (props) => {
    const styles = useStyleConfig('Checkbox')
    return (
        <ChakraCheckbox
            {...props}
            sx={styles}
            icon={<CustomCheckIcon isChecked={props.isChecked} />}
        />
    )
}

Checkbox.propTypes = {
    isChecked: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onChange: PropTypes.func,
    children: PropTypes.node,
}

export default Checkbox
